import { combineReducers } from 'redux'
import radarSettings from './radarSettings'
import phenomena from './phenomena'
import timelines from '@futures-platform/reducers/timelines'
import filters from './filters'
import signals from './signals'
import phenomenaList from './phenomenaList'
import dataContext from './dataContext'
import assessmentData from './assessmentData'

import {
    loading,
    errors,
    radarSets,
    phenomenaTypes,
    phenomenaTypesById,
    confirmDialog,
    sectors
} from '@futures-platform/reducers'

export default combineReducers({
    sectors,
    filters,
    phenomena,
    timelines,
    radarSettings,
    radarSets,
    loading,
    errors,
    phenomenaTypes,
    phenomenaTypesById,
    signals,
    confirmDialog,
    phenomenaList,
    dataContext,
    assessmentData
})
